import { Typography } from "@mui/material";
import { FC } from "react";

type TCompanyTitleProps = {
  text: string;
};

export const CompanyFormTitle: FC<TCompanyTitleProps> = ({ text }) => <Typography variant="sub16Bold">{text}</Typography>;
